import { Link, useNavigate, useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import MobileSidebar from './MobileSidebar';
import { useUser } from "../contexts/UserContext";
import { useMatch } from "../contexts/MatchContext";
import mobileOptions from '../assets/mobile-options.png'
import mobileHeader from '../assets/mobile-header.png'
import './MobileHeader.css'

const MobileHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { user, userData } = useUser();
    const { match, matchReady } = useMatch();
    const [showMobileSidebar, setShowMobileSidebar] = useState(false);
    const pic = userData?.profilePic || "profile1";

    // Check if the current page is a match page
    const isOnMatchPage = location.pathname.startsWith('/match/');
    const isAnonymous = user?.isAnonymous;

    return (
        <div className="mobile-header">
            <div className="mobile-options-container">
                <img src={mobileOptions} className="mobile-options" alt="open sidebar" onClick={() => setShowMobileSidebar(true)} />
            </div>
            {showMobileSidebar && (
                <MobileSidebar
                    onClose={() => setShowMobileSidebar(false)}
                    show={showMobileSidebar}
                />
            )}

            {/* Conditionally render match button or header image */}
            {match && matchReady && !isOnMatchPage ? (
                <button
                    className="mobile-match-button"
                    onClick={() => navigate(`/match/${match.id}`)}
                >
                    Go to Match
                </button>
            ) : (
                <div className="mobile-header-img-container">
                    <Link to="/">
                        <img src={mobileHeader} className="mobile-header-img" alt="mobile header" />
                    </Link>
                </div>
            )}

            {user && !isAnonymous ? (
                <Link className="home-user-icon-container" to={`/profile/${userData?.username}`}>
                    <img className="home-user-icon" src={`/assets/userIcon/${pic}.jpg`} alt="User" />
                </Link>
            ) : (
                <div className="mobile-header-buttons">
                    <Link className="header-button-link" to="/register">
                        <button className="mobile-signup-button">Sign Up</button>
                    </Link>
                    <Link className="header-button-link" to="/login">
                        <button className="mobile-login-button">Log In</button>
                    </Link>
                </div>
            )}
        </div>
    )
}

export default MobileHeader